import QRCode from 'qrcode'
import { useEffect, useRef } from 'react'

import styles from './qrCode.module.scss'

export interface QrCodeProps {
  value: string
  size?: number
  className?: string
}

export default function QrCode({ value, size = 168, className }: QrCodeProps) {
  const ref = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = ref.current
    if (!canvas) return

    // Render at 2x and scale down in CSS so the modules stay crisp on phones.
    QRCode.toCanvas(canvas, value, {
      width: size * 2,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#001018', light: '#ffffff' },
    })
      .then(() => {
        canvas.style.width = `${size}px`
        canvas.style.height = `${size}px`
      })
      .catch(() => {
        // A QR we cannot draw is better hidden than shown half-painted.
        canvas.style.display = 'none'
      })
  }, [value, size])

  return (
    <div className={className ? `${styles.panel} ${className}` : styles.panel}>
      <canvas
        ref={ref}
        className={styles.canvas}
        aria-hidden='true'
      />
    </div>
  )
}
